import { lazy } from 'react';
/** Открывает список промокодов */
export const PromoCodesPageAsync = lazy(() => import('./PromoCodes/PromoCodesPage'));